module.exports = __webpack_public_path__ + "static/media/logo_qoo10.93c1605a.svg";